import { render, staticRenderFns } from "./companyAnnouncement.vue?vue&type=template&id=7b07e9d6&scoped=true&"
import script from "./companyAnnouncement.vue?vue&type=script&lang=js&"
export * from "./companyAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./companyAnnouncement.vue?vue&type=style&index=0&id=7b07e9d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b07e9d6",
  null
  
)

export default component.exports